import { motion } from "framer-motion";
import { Heart, WheelchairMotion, CreditCard } from "@phosphor-icons/react";

export default function AboutUs() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-card">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="rounded-xl overflow-hidden border border-stone-200">
              <img
                src="https://images.pexels.com/photos/4489794/pexels-photo-4489794.jpeg"
                alt="Gerron, owner of Protech Mobile Mechanic"
                className="w-full h-[400px] lg:h-[520px] object-cover"
                loading="lazy"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-4 md:right-6 bg-background border border-stone-200 rounded-xl p-5 shadow-sm">
              <p className="font-heading font-extrabold text-3xl text-primary tracking-tight">4.8</p>
              <p className="text-xs text-muted-foreground font-medium mt-1">Star Rating</p>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            <p className="uppercase text-xs tracking-[0.2em] text-muted-foreground font-medium mb-4">
              Veteran-Owned
            </p>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-none mb-6">
              Master-Level Repair.
              <br />
              <span className="text-primary">Veteran Integrity.</span>
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-6 text-sm md:text-base">
              Protech Mobile Mechanic LLC is a veteran-owned and operated automotive service that brings master-level repair directly to the customer. Based in Hillsboro, we serve the greater Portland and Beaverton areas with a focus on integrity and specialized problem-solving.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-8 text-sm md:text-base">
              Known for the "G-Man" standard, Gerron is punctual, thoughtful, and engaging. He goes the extra mile to get you back on the road, providing a stress-free alternative to traditional shops through honest diagnostics and fair pricing at your location or our local Hillsboro shop.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="flex items-start gap-3 p-4 bg-background rounded-xl border border-stone-200" data-testid="about-feature-veteran">
                <Heart weight="duotone" className="w-5 h-5 text-primary mt-0.5 shrink-0" />
                <div>
                  <p className="font-heading font-bold text-sm">Veteran-Owned</p>
                  <p className="text-xs text-muted-foreground mt-1">Military-grade integrity & ethics</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-background rounded-xl border border-stone-200" data-testid="about-feature-location">
                <WheelchairMotion weight="duotone" className="w-5 h-5 text-primary mt-0.5 shrink-0" />
                <div>
                  <p className="font-heading font-bold text-sm">Hillsboro Based</p>
                  <p className="text-xs text-muted-foreground mt-1">Mobile & shop-based services</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-background rounded-xl border border-stone-200" data-testid="about-feature-rescue">
                <CreditCard weight="duotone" className="w-5 h-5 text-primary mt-0.5 shrink-0" />
                <div>
                  <p className="font-heading font-bold text-sm">Rescue Service</p>
                  <p className="text-xs text-muted-foreground mt-1">Fixed "DIY" projects gone wrong</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
